import { createContext, PropsWithChildren } from 'react'

interface IPortalContext {
  rootNode: Document | ShadowRoot
  containerParent: HTMLElement
  globalEventsNode: ShadowRoot | Window | Document
  popupPositionRoot?: HTMLElement
  subAppClass?: string
}

const defaultPortalContext: IPortalContext = {
  rootNode: document,
  containerParent: document.body,
  popupPositionRoot: undefined,
  globalEventsNode: window,
  subAppClass: undefined,
}

export const PortalContext = createContext<IPortalContext>(defaultPortalContext)

export const PortalProvider = ({
  children,
  ...overrides
}: PropsWithChildren<Partial<IPortalContext>>) => {
  return (
    <PortalContext.Provider value={{ ...defaultPortalContext, ...overrides }}>
      {children}
    </PortalContext.Provider>
  )
}
